import { type Plugin } from '@segment/analytics-next'

/**
 * This plugin is used to set the pageview_id for each page view and track event.
 */
export const pageviewIdPlugin = (getPageviewId: () => string): Plugin => {
  return {
    name: 'pageview-id',
    type: 'enrichment',

    isLoaded: () => true,
    load: () => Promise.resolve(),

    page: (ctx) => {
      ctx.updateEvent('properties.pageview_id', getPageviewId())

      return ctx
    },

    track: (ctx) => {
      ctx.updateEvent('properties.pageview_id', getPageviewId())

      return ctx
    },
  }
}
